const configuredApiBase = String(
  process.env.REACT_APP_API_BASE_URL || ''
).trim();

const defaultApiBase = process.env.NODE_ENV === 'development'
  ? `http://${window.location.hostname}:5000`
  : window.location.origin;

export const API_BASE = (configuredApiBase || defaultApiBase).replace(/\/$/, '');
